import script from "./ScaleBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ScaleBox.vue?vue&type=script&setup=true&lang=js"

import "./ScaleBox.vue?vue&type=style&index=0&id=b7670e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7670e36"]])

export default __exports__